// Hybec Air — hover-to-zoom on the PDP main product image. Horizon's own
// "zoom" setting only opens a click-triggered lightbox (zoom-dialog.js);
// there's no hover magnifier that lets a shopper scan the photo part by
// part without clicking, so this adds one as a lightweight overlay.
//
// Desktop / precise-pointer only (touch devices already get pinch-zoom in
// the lightbox via drag-zoom-wrapper.js). Pure CSS background-position
// "loupe" — moving the cursor over the image pans a magnified view of
// whichever part is under the pointer.
(function () {
  if (window.__hyHoverZoomInit) return;
  window.__hyHoverZoomInit = true;

  var canHover =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  var ZOOM_SIZE = '200%';

  function setup(container) {
    if (container.dataset.hyHoverZoom === 'done') return;

    var img = container.querySelector('img');
    if (!img) return;
    container.dataset.hyHoverZoom = 'done';

    var lens = document.createElement('div');
    lens.className = 'hy-hover-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    container.appendChild(lens);

    function setImage() {
      var src = img.currentSrc || img.src;
      if (src) lens.style.backgroundImage = 'url(' + src + ')';
    }

    if (img.complete) {
      setImage();
    } else {
      img.addEventListener('load', setImage, { once: true });
    }

    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      lens.style.backgroundPosition = x + '% ' + y + '%';
      lens.style.opacity = '1';
    });

    container.addEventListener('mouseleave', function () {
      lens.style.opacity = '0';
    });
  }

  function scan() {
    document
      .querySelectorAll("main[data-template='product'] .product-media-container--zoomable")
      .forEach(setup);
  }

  scan();

  var observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
})();
